<script>
	import AudioVisualiser from './audio-visualiser/AudioVisualiser.svelte'
</script>

<main>
	<AudioVisualiser />
</main>

<style>
	main {
		text-align: center;
	}
</style>